<mat-form-field
  appearance="outline"
  class="search-field"
  subscriptSizing="dynamic"
>
  <input
    matInput
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (input)="onInput($any($event.target).value)"
    (blur)="onTouched()"
  />
  <ng-container matSuffix>
    <div class="flex flex-row items-center">
      <!-- Kept in the layout while empty so the search icon never shifts. -->
      <button
        [style.visibility]="value ? 'visible' : 'hidden'"
        mat-icon-button
        aria-label="Clear search"
        class="clear-button m-0 p-0"
        (click)="clear()"
      >
        <mat-icon class="text-primary-text">close</mat-icon>
      </button>
      <mat-icon class="text-primary-text">search</mat-icon>
    </div>
  </ng-container>
</mat-form-field>
